<mat-card class="content-card">
  <div fxLayout="row">
    <ng-container *ngIf="order && !loadingOrder">


        <div fxFlex="30">
          <span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span> &nbsp;

          <button class="mr-1" mat-raised-button color="primary" [disabled]="loadingPrevNext || !prevNextIds?.prevId" (click)="gotoPrevOrder()">Prev</button>
          <button class="mr-2" mat-raised-button color="primary" [disabled]="loadingPrevNext || !prevNextIds?.nextId" (click)="gotoNextOrder()">Next</button>

        </div>
      <div fxFlex="40" style="text-align: center;">
        <span *ngIf="order.status == orderStatus.Shipped" style="background-color: #e4ffdd; padding: 0 15px; margin-right: 5px;">
          <b>Shipped</b>
        </span>
        <span *ngIf="referral" style="background-color: #f7fddc; padding: 0 15px; margin-right: 5px;">
          <b>Referral</b>
        </span>
        <span *ngIf="order.status == orderStatus.Created" style="background-color: #9f9f9f; padding: 0 15px; margin-right: 5px;">
          <b>Created</b>
        </span>
        <span *ngIf="order.status == orderStatus.InProduction" style="background-color: #edf8a7; padding: 0 15px; margin-right: 5px;">
          <b>In Production</b>
        </span>
        <span *ngIf="order.status == orderStatus.Cancelled" style="background-color: #ff7272; padding: 0 15px; margin-right: 5px;">
          <b>Cancelled</b>
        </span>
        <span *ngIf="order.isReorderOrder" style="background-color: lightskyblue; padding: 0 15px; margin-right: 5px;">
          <b>Re-Order</b>
        </span>
      </div>
        <div fxFlex="30" style="text-align: right">
          <button class="mr-2" mat-raised-button color="blue" *ngIf="currentUserIsAdmin() && allowEditOrder()" routerLink="edit">
            <mat-icon>edit</mat-icon>
            Edit
          </button>
          <button mat-raised-button color="warn" *ngIf="order && currentUserIsAdmin()" [disabled]="cancelOrderDisabled()"
                  (click)="cancelOrder()"><mat-icon>delete</mat-icon> Cancel</button>
        </div>

    </ng-container>
</div>
</mat-card>


<div class="content-card" fxLayout="row wrap" fxLayoutGap="10px">

  <!-- #region order details -->

  <mat-card class="container-md" style="min-width: 400px;">
    <mat-progress-bar mode="indeterminate" *ngIf="loadingOrder" class="progress-bar"></mat-progress-bar>

    <mat-card-content class="mt-2">
      <h3>Order</h3>
      <span class="mr-2" *ngIf="!order && !loadingOrder">Order not exist/or has been removed</span>
      <span class="mr-2" *ngIf="loadingOrder">Loading order data...</span>
      <div *ngIf="order">


        <div class="list-item" fxLayout="row" *ngFor="let field of fields ">
          <app-content-row [field]="field" [entity]="order"></app-content-row>
        </div>
        <ng-container *ngIf="order && order.cancellationReason != null">
        <div class="list-item" fxLayout="row" *ngFor="let field of cancellationFields">
          <app-content-row [field]="field" [entity]="order"></app-content-row>
        </div>
        </ng-container>


      </div>
    </mat-card-content>
    <mat-card-actions align="end" class="mt-2">

    </mat-card-actions>
  </mat-card>

  <!-- #endregion order details -->

  <div fxFlex="50">

    <div style="margin-left: 10px; margin-bottom: 10px;" *ngIf="referral">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>🎁 Referred by {{ referral.customer.firstName }} {{ referral.customer.lastName }}</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsReferral ">
          <app-content-row [field]="field" [entity]="referral"></app-content-row>
        </div>

      </mat-expansion-panel>
    </div>

    <div style="margin-left: 10px; margin-bottom: 10px;" *ngIf="order && order.isVirtualOnly">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Virtual-Only</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        The card created by this order will be virtual-only
      </mat-expansion-panel>
    </div>

    <div style="margin-left: 10px; margin-bottom: 10px;" *ngIf="order && order.source && !order.source.startsWith('app-')">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Source: {{order.source}}</h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        The source of this order is: {{order.source}}
      </mat-expansion-panel>
    </div>

    <div style="margin-left: 10px; margin-bottom: 10px;" *ngIf="order && order.source && order.source.startsWith('app-') && order.appDevice">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>
              Source: <ng-container *ngIf="order && order.appDevice">APP <mat-icon *ngIf="order.appDevice.os == 1">apple</mat-icon><mat-icon *ngIf="order.appDevice.os == 2">android</mat-icon></ng-container>
              <ng-container style="margin-left: 10px;" *ngIf="order && order.appDevice && order.appDevice.isBlacklisted">
                <span style="color: red;">DEVICE BLACKLISTED</span></ng-container>
            </h4>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="list-item" fxLayout="row" *ngFor="let field of fieldsSource ">
          <app-content-row [field]="field" [entity]="order"></app-content-row>
        </div>

        <div style="text-align: right; margin-top: 10px;">
          <ng-container *ngIf="order && order.appDevice && !order.appDevice.isBlacklisted">
            <button mat-raised-button color="accent" (click)="blacklistAppDevice()">Blacklist device</button>
          </ng-container>
          <ng-container *ngIf="order && order.appDevice && order.appDevice.isBlacklisted">
            <button mat-raised-button color="primary" (click)="unBlacklistAppDevice()">Remove device from Blacklist</button>
          </ng-container>
        </div>

      </mat-expansion-panel>
    </div>

    <!-- warnings -->
    <div *ngIf="order && order.webIdTransaction" style="margin-left: 10px;">
      <div *ngIf="order.webIdTransaction.status == identStatus.fail" style="border-radius: 4px; background-color: red; color: white; font-weight: bold; margin-bottom: 5px; padding: 10px;">
        <mat-icon style="color: white">beenhere</mat-icon> Ident failed!
      </div>
      <div *ngIf="order.webIdTransaction.pepStatus == pepStatus.possibleMatch" style="border-radius: 4px; background-color: #ff9900; font-weight: bold; margin-bottom: 5px; padding: 10px;">
        <mat-icon style="color: white">perm_identity</mat-icon> Possible PEP match!
      </div>
      <div *ngIf="order.webIdTransaction.pepStatus == pepStatus.confirmedMatch" style="border-radius: 4px; background-color: red; color: white; font-weight: bold; margin-bottom: 5px; padding: 10px;">
        <mat-icon style="color: white">perm_identity</mat-icon> Confirmed PEP match!
      </div>
    </div>


    <!-- #region reorder details -->
    <ng-container *ngIf="order && order.isReorderOrder">
      <mat-card style="margin-left: 10px; margin-bottom: 10px;">
        <mat-card-content>

          <div style="background-color: lightskyblue; padding: 0 15px">
            <h4>Re-Order</h4>
          </div>


          <div class="list-item" fxLayout="row" *ngFor="let field of reorderFields ">
            <app-content-row [field]="field" [entity]="order"></app-content-row>
          </div>

        </mat-card-content>


      </mat-card>

    </ng-container>
    <!-- #region reorder details -->


    <!-- #region card details -->
    <ng-container *ngIf="loadCardData">
      <mat-card style="margin-left: 10px;">
        <mat-progress-bar mode="indeterminate" *ngIf="loadCardData" class="progress-bar"></mat-progress-bar>
        <div style="margin-top: 10px;">
          Loading card data...
        </div>
      </mat-card>
    </ng-container>
    <ng-container *ngIf="!loadCardData && !card">
      <mat-card style="margin-left: 10px;">
        No card was created from this order yet.
      </mat-card>

    </ng-container>
    <ng-container *ngIf="!loadCardData && card ">
      <mat-accordion style="margin-left: 10px;" class="mat-card">
        <mat-expansion-panel disabled=true>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Card
            </mat-panel-title>
            <mat-panel-title>
              Product
            </mat-panel-title>
            <mat-panel-title>
              Status
            </mat-panel-title>
            <mat-panel-title>
              Expiry date
            </mat-panel-title>
            <mat-panel-title>
              Last Payment Reminder
            </mat-panel-title>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="card != null">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{card.token}}
            </mat-panel-title>
            <mat-panel-title>
              {{card.product?.internalName}}
            </mat-panel-title>
            <mat-panel-title class=" {{card.status == 6 ? 'warning-row' : ''}}">
              {{card.statusName}}
            </mat-panel-title>
            <mat-panel-title>
              {{card.expireDate | date: 'MM/yy'}}
            </mat-panel-title>
            <mat-panel-title>
              {{card.order.paymentEmailReminders && card.order.paymentEmailReminders[card.order.paymentEmailReminders.length - 1] | date: 'dd.MM.yyyy'}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="list-item" fxLayout="row" *ngFor="let field of cardFields;">
            <app-content-row [field]="field" [entity]="card"></app-content-row>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
    <!-- #endregion card details -->

    <!-- #region sent reminders -->

    <app-sent-reminders style="display: block; margin-left: 10px;" [orderId]="orderId"></app-sent-reminders>


    <app-event-log-view class="log-card" [logs]="logs" *ngIf="showLogs()"></app-event-log-view>

    <!-- #endregion sent reminders -->

  </div>
</div>
